import { render, staticRenderFns } from "./pentestDetail.vue?vue&type=template&id=bd7a9e80"
import script from "./pentestDetail.vue?vue&type=script&lang=js"
export * from "./pentestDetail.vue?vue&type=script&lang=js"
import style0 from "./pentestDetail.vue?vue&type=style&index=0&id=bd7a9e80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports